import PageBanner from "components/BannerSection/PageBanner";
import CallToSectionTwo from "components/CallToSection/CallToSectionTwo";
import HeaderOne from "components/Header/HeaderOne";
import MobileMenu from "components/Header/MobileMenu";
import Layout from "components/Layout/Layout";
import MainFooter from "components/MainFooter/MainFooter";
import Style from "components/Reuseable/Style";
import SearchPopup from "components/SearchPopup/SearchPopup";
import React from "react";
import PartnerOne from "components/PartnerSection/PartnerOne";
import GallerySectionTechSol from "components/GallerySection/GallerySectionTechSol";
const TechSolutions = () => {
  return (
    <Layout pageTitle="Tech Solutions">
      <Style />
      <HeaderOne />
      <MobileMenu />
      <SearchPopup />
      <PageBanner
        title="Tech Solutions"
        parent="Services"
        parentHref="/services"
      />
      <PartnerOne />
      <GallerySectionTechSol portfolio />
      <CallToSectionTwo className="alternate" />
      <MainFooter />
    </Layout>
  );
};

export default TechSolutions;
